import { render } from "./NavView.vue?vue&type=template&id=2bce70ff"
import script from "./NavView.vue?vue&type=script&lang=js"
export * from "./NavView.vue?vue&type=script&lang=js"

import "./NavView.vue?vue&type=style&index=0&id=2bce70ff&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__